import { render, staticRenderFns } from "./EmpleadoNew.vue?vue&type=template&id=b8c39fbe&scoped=true&"
import script from "./EmpleadoNew.vue?vue&type=script&lang=js&"
export * from "./EmpleadoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c39fbe",
  null
  
)

export default component.exports